/**
 * 充币 提币 快捷币种选择
 */

import React from 'react';
import './HotCoin.less';

class HotCoin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onHandleChange = (item) => {
    this.props.changeCoin(item);
  };

  render() {
    const { hotList, curId } = this.props;
    return (
      <div className="hot-list-con">
        <ul>
          {hotList.map((item, index) => {
            return (
              <li
                className={`hot-coin-item ${
                  curId === item.currencyId ? 'cur' : ''
                }`}
                key={index}
                onClick={() => {
                  this.onHandleChange(item);
                }}
              >
                {item.currency}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default HotCoin;
